const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteJutgeFile = async (id_problema: string, id_usuari: string, uid: string, id_activitat: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/activitats/${id_activitat}/problemes/${id_problema}/usuaris/${id_usuari}/upload/${uid}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            return { response: 'OK' };
        } else {
            return { response: 'ERROR' };
        }
    } catch (error) {
        console.log('Error deleting file:', error);
        return { response: 'ERROR' };
    }
};
